export const ADDONS = {
  RETURN_USB: 'RETURN_USB',
  RETURN_ART: 'RETURN_ART',
  EXTRA_BOOKS: 'EXTRA_BOOKS',
  SUBSCRIPTION: 'SUBSCRIPTION',
  VIP_SUBSCRIPTION: 'VIP_SUBSCRIPTION',
  OTHER: 'OTHER',
}
